"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

var _react = require("react");

var _OSM = _interopRequireDefault(require("ol/source/OSM"));

var _EditLayerForm = _interopRequireDefault(require("../EditLayerForm/EditLayerForm"));

var _GeneralTab = _interopRequireDefault(require("../../tabs/general/GeneralTab/GeneralTab"));

var _OSMSourceTab = _interopRequireDefault(require("../../tabs/source/OSMSourceTab/OSMSourceTab"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["source"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EditOSMLayerForm = function EditOSMLayerForm(_ref) {
  var layer = _ref.layer,
      onFinish = _ref.onFinish;
  var onInternalFinish = (0, _react.useCallback)(function (values) {
    var source = values.source,
        properties = _objectWithoutProperties(values, _excluded);

    layer.setProperties(properties);

    if (source) {
      if (layer.getSource() instanceof _OSM.default) {
        //set urls
        if (source.url && Array.isArray(source.url)) {
          layer.getSource().setUrls(source.url);
        } else if (source.url && (typeof source.url === 'string' || source.url instanceof String)) {
          layer.getSource().setUrls(source.url.split(','));
        } //set attributions


        if (source.attributions && Array.isArray(source.attributions)) {
          layer.getSource().setAttributions(source.attributions);
        } else if (source.attributions && (typeof source.attributions === 'string' || source.attributions instanceof String)) {
          layer.getSource().setAttributions(source.attributions.split(','));
        }
      }
    } //execute onFinish


    onFinish && onFinish(values);
  }, [layer, onFinish]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditLayerForm.default, {
    layer: layer,
    onFinish: onInternalFinish,
    tabs: [{
      title: "General",
      key: "general",
      isDefault: true,
      el: _GeneralTab.default
    }, {
      title: "Source",
      key: "source",
      el: _OSMSourceTab.default
    }]
  });
};

var _default = EditOSMLayerForm;
exports.default = _default;